


import Vue from "vue";
import AppTier0 from "./upgrades/Tier0.vue";
import AppTier1 from "./upgrades/Tier1.vue";
import AppTier2 from "./upgrades/Tier2.vue";
import { UpgradeService } from "@/services/upgrade-service";
import AppDemoShedule from "@/components/account/DemoShedule.vue";

export default Vue.extend({
	data(){
		return {
			toggleDemoShedule: false,
		};
	},
	props: {
		tier: {
			type: Number,
			default: 0
		}
	},
	methods: {
		close(){
			UpgradeService.showUpgradeModal(this.tier);
		}
	},
	components: {
		AppTier0,
		AppTier1,
		AppTier2,
		AppDemoShedule
	},
});
